/*
    Migrate functions from BusinessUtils.js to TypeScript
*/

import { TGeneralAges, TItem } from "./store/types";

export const getGeneralAgeCategoryPrices = (item: TItem, generalAges: TGeneralAges) => {
    const prices = generalAges[item.type].reduce((hashmap, generalAge) => {
        const priceFieldName: "price" | "pricec1" | "pricec2" | "pricec3" | "pricec4" =
            generalAge.agecat === "c5" ? "price" : `price${generalAge.agecat}`;
        const price = item[priceFieldName] ?? 0;

        hashmap.set(generalAge.key, price);

        return hashmap;
    }, new Map<string, number>());

    return prices;
};

/**
 * Check if a JWT token is expired
 *
 * @param token - The JWT token to check
 * @returns true if the token is expired, false otherwise
 */
export const isJwtTokenExpired = (token: string) => {
    if (!token) return true;

    try {
        const parts = token.split(".");

        if (parts.length !== 3) {
            return true;
        }

        const payload = JSON.parse(atob(parts[1]));
        const { exp } = payload;

        if (!exp) {
            return true;
        }

        return Date.now() >= exp * 1000;
    } catch (e) {
        return true;
    }
};
